import { useParams } from 'react-router-dom';
import { Card, Col, Flex, Row, Skeleton } from 'antd';
import { DefaultPageLayout } from 'layouts/default-page-layout';
import { useGetExpense } from 'api/expenses/use-get-expense.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard';
import { ECommentEntityName } from 'types/comment.ts';
import { ClientInfoCard } from 'components/clients/client-info-card';
import { CommentsCard } from 'components/comments/comments-card';
import { DocumentsList } from 'components/documents/documents-list';
import { DocumentsUpload } from 'components/documents/documents-upload';
import { ExpenseInfoCard } from 'components/expenses/expense-info-card';
import { ExpensePageHeader } from 'components/expenses/expense-page-header';

export const ExpensePageComponent = () => {
  const { expenseId } = useParams();

  const { data: expense, isLoading } = useGetExpense(Number(expenseId));

  const header = !isLoading && expense ? <ExpensePageHeader expense={expense} /> : undefined;

  return (
    <DefaultPageLayout header={header}>
      {!isLoading && expense ? (
        <Row gutter={16}>
          <Col span={17}>
            <Card style={{ width: '100%' }}>
              <DocumentsUpload expenseId={expense.id} />
              <DocumentsList expenseId={expense.id} />
            </Card>
          </Col>
          <Col span={7}>
            <Flex gap='middle' vertical>
              {expense.partner ? (
                <ClientInfoCard client={expense.partner} contact={expense.contact ?? undefined} />
              ) : null}
              <ExpenseInfoCard expense={expense} />
              <CommentsCard entityName={ECommentEntityName.expenses} entityId={expense.id} />
            </Flex>
          </Col>
        </Row>
      ) : (
        <Skeleton />
      )}
    </DefaultPageLayout>
  );
};

export const ExpensePage = withRoleGuard(ExpensePageComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
